import React, { Component } from 'react'
import { arrayOf, string, shape } from 'prop-types'

import { Modal, ModalBody, SVGIcon } from 'components/qstrap'
import TmvnCarousel from 'components/molecules/TmvnCarousel'
import Relazsizes from 'relazsizes'

import triggerEvent from 'utils/dataLayer'

class ImagesGallery extends Component {
  state = {
    activeIdx: 0,
    lightbox: false,
  }

  setActiveIdx = (idx) => {
    this.setState({
      activeIdx: idx,
    })
  }

  toggleLightBox = () => {
    this.setState({
      lightbox: !this.state.lightbox,
    })
  }

  showLightBox = () => {
    if (!this.state.lightbox) {
      this.setState({
        lightbox: true,
      })
    }
  }

  renderGallery = (lightboxMode) => {
    const { images } = this.props
    const { activeIdx } = this.state
    const imgNodes = images.map(img => (
      <Relazsizes
        dataSrc={lightboxMode ? img.original_url : img.medium_url}
        alt=""
      />)
    )

    return (
      <>
        <div className="images-gallery__show" onClick={this.showLightBox}>
          {
            !lightboxMode &&
            <div className="images-gallery__zoom">
              <p className="images-gallery__zoom-text">Klik untuk perbesar gambar</p>
            </div>
          }
          <TmvnCarousel
            id={lightboxMode ? 'img-gallery-lbox' : 'img-gallery-imgs'}
            indicators={false}
            activeItm={activeIdx}
            items={imgNodes}
            controlled
          />
        </div>
        <div className="images-gallery__list">
          {
            images.map((img, idx) => (
              <div
                className={`
                  images-gallery__thumbnail
                  ${activeIdx === idx ? 'image-gallery-thumbnail--active' : ''}
                `}
                onClick={() => {
                  this.setActiveIdx(idx)
                  triggerEvent('ga/campus/card-photo/galeri')
                }}
                key={`img-thmb-${img.thumb_url}`}
              >
                <Relazsizes src={img.thumb_url} alt=""/>
              </div>
            ))
          }
        </div>
        <style jsx>
          {`
            .images-gallery {
              &__show {
                cursor: pointer;
                position: relative;
                :global(img) {
                  width: 100%;
                }
                .images-gallery__zoom {
                  display: none;
                }
                p.images-gallery__zoom-text {
                  color: #fff;
                  font-size: 16px;
                }
                &:hover {
                  .images-gallery__zoom {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background: rgba(0,0,0, .5);
                  }
                }
              }
              &__list {
                width: 100%;
                margin: 16px -8px;
                display: flex;
                flex-wrap: nowrap;
                overflow-y: auto;
                overflow-x: auto;
                &::-webkit-scrollbar-track {
                  border-radius: 10px;
                  width: 5px;
                  background-color: #bed2e8;
                }
                &::-webkit-scrollbar {
                  border-radius: 10px;
                  width: 5px;
                  background-color: #bed2e8;
                }
                &::-webkit-scrollbar-thumb {
                  border-radius: 10px;
                  width: 5px;
                  background-color: #0fc3c4;
                }
                :global(img) {
                  width: 90px;
                  height: 90px;
                  object-fit: cover;
                  object-position: center;
                }
              }
              &__thumbnail {
                display: inline-block;
                padding: 8px;
                margin-bottom: 8px;
                border: solid 2px #fff;
                cursor: pointer;
                &.image-gallery-thumbnail--active {
                  border: solid 2px #0fc3c4;
                }
              }
            }
            .slide-in-left {
              animation: slide-in-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
            }
            @keyframes slide-in-left {
              0% {
                transform: translateX(-1000px);
                opacity: 0;
              }
              100% {
                transform: translateX(0);
                opacity: 1;
              }
            }
            .slide-in-right {
              animation: slide-in-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
            }
            @keyframes slide-in-right {
              0% {
                transform: translateX(1000px);
                opacity: 0;
              }
              100% {
                transform: translateX(0);
                opacity: 1;
              }
            }
          `}
        </style>
      </>
    )
  }

  render() {
    return (
      <div className="images-gallery">
        { this.renderGallery() }
        {
          this.state.lightbox &&
          <Modal
            autoFocus={false}
            fade={false}
            toggle={this.toggleLightBox}
            className="images-gallery__lightbox"
            isOpen
          >
            <ModalBody>
              <button className="btn-close pull-right" type="button" onClick={this.toggleLightBox}>
                <SVGIcon name="common-close" size="md"/>
              </button>
              <div
                className="image-gallery__modal-wrapper"
                style={{
                  display: 'inline-block',
                  width: '100%',
                }}
              >
                { this.renderGallery(true) }
              </div>
            </ModalBody>
          </Modal>
        }
        <style jsx>
          {`
            .images-gallery {
              :global(&__lightbox) {
                @media screen and (min-width: 768px) {
                  max-width: 60rem;
                }
                @media screen and (max-width: 767px) {
                  margin: 0;
                }
                :global(.modal-body) {
                  @media screen and (max-width: 767px) {
                    height: 100vh;
                  }
                }
                :global(.modal-content) {
                  box-shadow: none !important;
                  border: none;
                  border-radius: 0;
                  @media screen and (max-width: 767px) {
                    border: none;
                    border-radius: 0;
                    box-shadow: unset;
                  }
                  @media screen and (max-width: 767px) {
                    margin: 0;
                  }
                  button.btn-close {
                    background: transparent;
                    border: none;
                    margin-bottom: 16px;
                    @media screen and (min-width: 768px) {
                      display: none;
                    }
                  }
                }
              }
            }
          `}
        </style>
      </div>
    )
  }
}

ImagesGallery.propTypes = {
  images: arrayOf(shape({
    medium_url: string,
    thumb_url: string,
    original_url: string,
  })),
}

export default ImagesGallery
